import client from '../axios';
import { GET_HQ_DETAIL, POST_ORDERFIRST, PUT_HQ_DETAIL, PUT_ORDERFIRST, GET_DELIVERY_SUPPORT, POST_NEWSLETTER_DATE, POST_NEWSLETTER_DATE_ALL, POST_CLASSREQUEST, GET_NOT_ORDER_MEMBER, GET_DEL_REQUEST_MEMBER, POST_DELIVERY_SUPPORT, GET_ORDER_LIMIT, POST_ORDER_LIMIT, POST_HQ_BRANCH_CLOSINGREPORT, GET_AUTH_ORG_LIST, GET_AUTH_ACCOUNT, GET_AUTH_ACCOUNT_CHECK, POST_AUTH_ACCOUNT_CHECK, POST_ORGMANAGE_MEMBER, GET_MEMBER_POSITION, PUT_ORGMANAGE_MEMBER, DELETE_ORGMANAGE_MEMBER, PUT_ORGMANAGE_TEAM, DELETE_ORGMANAGE_TEAM, POST_ORGMANAGE_TEAM, GET_TOTAL_ORDER_MEMBER } from './endpoint';

//교육원 소식지 기한 설정
export const postNewletterDateAPI = (data) => {
  return client.post(POST_NEWSLETTER_DATE, data);
};

//지사 소식지 기한 설정
export const postNewletterDateAllAPI = (data) => {
  return client.post(POST_NEWSLETTER_DATE_ALL, data);
};

//지사 추가
export const postBranchAPI = (data) => {
  console.log(data);
  // return client.post(POST_HQ_BRANCH_MANAGE_ADDBRANCH, data);
};

// 초도물품 주문신청
export const postOrderFirstAPI = (data) => {
  return client.post(POST_ORDERFIRST, data);
};

// 초도물품 주문상태 일괄수정
export const putOrderFirstAPI = (data) => {
  return client.put(PUT_ORDERFIRST, data);
};

// 본사 상세
export const getHqAPI = (idx) => {
  return client.get(GET_HQ_DETAIL.replace(':hq_idx', idx));
};

// 본사 상세 수정
export const putHqAPI = ({ idx, data }) => {
  console.log(data);
  return client.put(PUT_HQ_DETAIL.replace(':hq_idx', idx), data);
};

// 배송비 지원 설정 목록
export const getDeliverysupportAPI = () => {
  return client.get(GET_DELIVERY_SUPPORT);
};

// 배송비 지원 설정 지원/지원중단
export const postDeliverysupportAPI = (data) => {
  return client.post(POST_DELIVERY_SUPPORT, data);
};

// 주문 제한 기간 설정 목록
export const getOrderLimitAPI = () => {
  return client.get(GET_ORDER_LIMIT);
};

// 주문 제한 기간 사용여부/기간 수정
export const postOrderLimitAPI = (data) => {
  return client.post(POST_ORDER_LIMIT, data);
};

// 수업 승인 요청관리 - 예외교습 승인/반려
export const postClassRequestAPI = (data) => {
  return client.post(POST_CLASSREQUEST, data);
};

// 교육원 주문현황 - 총주문 회원 목록
export const getTotalOrderMemberAPI = (branch_idx, school_idx, teacher_idx, yyyymm) => {
  return client.get(GET_TOTAL_ORDER_MEMBER.replace(':branch_idx', branch_idx).replace(':school_idx', school_idx).replace(':teacher_idx', teacher_idx).replace(':yyyymm', yyyymm));
};
// 교육원 주문현황 - 미주문 회원 목록
export const getNotOrderMemberAPI = (branch_idx, school_idx, teacher_idx, yyyymm) => {
  return client.get(GET_NOT_ORDER_MEMBER.replace(':branch_idx', branch_idx).replace(':school_idx', school_idx).replace(':teacher_idx', teacher_idx).replace(':yyyymm', yyyymm));
};

// 교육원 주문현황 - 휴회/졸업(삭제) 신청 회원 목록
export const getDelRequestMemberAPI = (branch_idx, school_idx, teacher_idx, yyyymm) => {
  return client.get(GET_DEL_REQUEST_MEMBER.replace(':branch_idx', branch_idx).replace(':school_idx', school_idx).replace(':teacher_idx', teacher_idx).replace(':yyyymm', yyyymm));
};

// 지사 마감보고서 승인/반려
export const postHqBranchClosingReport = (data) => {
  return client.post(POST_HQ_BRANCH_CLOSINGREPORT, data);
};

// 관리자 계정관리
export const getAuthOrgAPI = () => {
  return client.get(GET_AUTH_ORG_LIST);
}

// 권한 부여
export const getAuthAccountAPI = () => {
  return client.get(GET_AUTH_ACCOUNT);
}

// 권한 목록 가져오기
export const getAuthAccountCheckAPI = (hq_idx) => {
  return client.get(GET_AUTH_ACCOUNT_CHECK.replace(':hq_idx', hq_idx));
}

// 권한 부여하기
export const postAuthAccountCheckAPI = (hq_idx, data) => {
  return client.post(POST_AUTH_ACCOUNT_CHECK.replace(':hq_idx', hq_idx), data);
}

export const postOrgManageMemberAPI = (data) => {
  return client.post(POST_ORGMANAGE_MEMBER, data);
}

export const putOrgManageMemberAPI = (data) => {
  return client.put(PUT_ORGMANAGE_MEMBER, data);
}

export const deleteOrgManageMemberAPI = (idx) => {
  return client.delete(DELETE_ORGMANAGE_MEMBER.replace(':member_idx', idx));
}

export const getMemberPositionAPI = () => {
  return client.get(GET_MEMBER_POSITION);
}

export const putOrgManageTeamAPI = (data) => {
  return client.put(PUT_ORGMANAGE_TEAM, data);
}

export const postOrgManageTeamAPI = (data) => {
  return client.post(POST_ORGMANAGE_TEAM, data);
}

export const deleteOrgManageTeamAPI = (idx) => {
  return client.delete(DELETE_ORGMANAGE_TEAM.replace(':team_idx', idx));
}
